// extracted by mini-css-extract-plugin
module.exports = {"mobilePhone":"UserSettings_mobilePhone__2uw3O","verify":"UserSettings_verify__QtrmX"};